import React, { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTheme } from '../context/ThemeContext';

function FeeInfoButton({ size = 14 }) {
  const [open, setOpen] = useState(false);
  const { colors } = useTheme();

  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        aria-label="Mas informacion sobre gastos de gestion"
        style={{
          background: 'transparent',
          border: 'none',
          padding: 0,
          margin: 0,
          marginLeft: 4,
          cursor: 'pointer',
          color: colors.textSecondary,
          display: 'inline-flex',
          alignItems: 'center',
          verticalAlign: 'middle',
          opacity: 0.7,
        }}
      >
        <InfoOutlinedIcon style={{ fontSize: size }} />
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed', inset: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: colors.bgSecondary,
              border: `1px solid ${colors.border}`,
              borderRadius: '16px',
              padding: '1.5rem',
              maxWidth: '420px', width: '100%',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
              <h3 style={{ color: colors.text, margin: 0, fontSize: '1rem' }}>Gastos de gestion</h3>
              <button
                onClick={() => setOpen(false)}
                aria-label="Cerrar"
                style={{ background: 'transparent', border: 'none', color: colors.textSecondary, cursor: 'pointer', fontSize: '1.2rem', padding: 0, lineHeight: 1 }}
              >
                X
              </button>
            </div>
            <p style={{ color: colors.textSecondary, fontSize: '0.88rem', lineHeight: 1.6, margin: 0 }}>
              Los gastos de gestion cubren los costes operativos asociados a tu compra: procesamiento del pago, generacion del codigo QR, atencion al cliente y mantenimiento de la plataforma.
            </p>
            <p style={{ color: colors.textSecondary, fontSize: '0.88rem', lineHeight: 1.6, margin: '0.6rem 0 0 0' }}>
              El importe exacto se muestra siempre antes de confirmar el pago.
            </p>
            <button
              onClick={() => setOpen(false)}
              style={{
                backgroundColor: colors.accent,
                color: colors.accentText,
                border: 'none',
                borderRadius: '8px',
                padding: '0.6rem 1.2rem',
                marginTop: '1.2rem',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '0.85rem',
                width: '100%',
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default FeeInfoButton;